export const CHARGES_RECEIVED = "CHARGES_RECEIVED";
export const SET_CHARGE = "SET_CHARGE";
